import { window } from 'browser-monads';

export function getCurrentProjectType() {
  return window.localStorage.getItem('currentProjectType') || 'all';
}

export function setCurrentProjectTypeOnLocaleStorage(type) {
  window.localStorage.setItem('currentProjectType', type);
}
